(function () {
  'use strict';

  /* Match the theme's own header breakpoint. The theme shows its desktop
     header at 750px, so the mega menu must switch at the same width. */
  var BP = 750;

  function initMegaMenu() {
    var root = document.querySelector('[data-gta-menu-root]');
    if (!root || root.getAttribute('data-gta-initialized') === 'true') return;

    var template = root.querySelector('#gta-mobile-template');
    if (!document.getElementById('gta-drawer') && template) {
      document.body.appendChild(template.content.cloneNode(true));
    }

    var drawer = document.getElementById('gta-drawer');
    var scrim = document.getElementById('gta-scrim');
    var closeBtn = drawer && drawer.querySelector('.gta-drawer__close');
    if (!drawer || !scrim || !closeBtn) return;

    root.setAttribute('data-gta-initialized', 'true');

    var navButtons = root.querySelectorAll('.gta-nav__link[aria-haspopup]');
    var scrimTimer = null;

    function closeAllPanels() {
      navButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel) panel.classList.remove('is-open');
      });
    }

    navButtons.forEach(function (button) {
      var item = button.closest('.gta-nav__item');
      button.addEventListener('click', function () {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        var isOpen = button.getAttribute('aria-expanded') === 'true';
        closeAllPanels();
        if (!isOpen && panel) {
          button.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
        }
      });
      button.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeAllPanels();
          button.focus();
        }
      });
      if (item) {
        item.addEventListener('mouseenter', function () {
          button.setAttribute('aria-expanded', 'true');
        });
        item.addEventListener('mouseleave', function () {
          button.setAttribute('aria-expanded', 'false');
          var panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) panel.classList.remove('is-open');
        });
      }
    });

    root.querySelectorAll('.gta-nav__item').forEach(function (item, index) {
      var topButton = item.querySelector('.gta-nav__link');
      var panel = item.querySelector('.gta-panel');
      if (!topButton || !panel) return;

      var section = document.createElement('div');
      var bodyId = 'gta-acc-body-' + index;
      section.className = 'gta-acc';
      section.innerHTML =
        '<button type="button" class="gta-acc__btn" aria-expanded="false" aria-controls="' + bodyId + '">' +
          topButton.textContent.trim() +
          '<svg class="gta-caret" width="14" height="14" aria-hidden="true"><use href="#i-caret"></use></svg>' +
        '</button>' +
        '<div class="gta-acc__body" id="' + bodyId + '"></div>';

      var body = section.querySelector('.gta-acc__body');
      var shopAll = panel.querySelector('.gta-apparel-shop-all');
      if (shopAll) body.appendChild(shopAll.cloneNode(true));
      var sportDirectoryCtas = panel.querySelector('.gta-sport-directory-ctas');
      if (sportDirectoryCtas) {
        body.appendChild(sportDirectoryCtas.cloneNode(true));
      }
      panel.querySelectorAll('.gta-col').forEach(function (column) {
        body.appendChild(column.cloneNode(true));
      });
      var styleCut = panel.querySelector('.gta-style-cut');
      if (styleCut && panel.id) body.setAttribute('data-gta-style-cut-source', panel.id);
      drawer.appendChild(section);
    });

    drawer.querySelectorAll('.gta-acc__btn').forEach(function (button) {
      button.addEventListener('click', function () {
        var body = document.getElementById(button.getAttribute('aria-controls'));
        var isOpen = button.getAttribute('aria-expanded') === 'true';

        drawer.querySelectorAll('.gta-acc__btn').forEach(function (otherButton) {
          otherButton.setAttribute('aria-expanded', 'false');
          var otherBody = document.getElementById(otherButton.getAttribute('aria-controls'));
          if (otherBody) otherBody.style.maxHeight = '';
        });

        if (!isOpen && body) {
          var sourceId = body.getAttribute('data-gta-style-cut-source');
          if (sourceId && body.getAttribute('data-gta-style-cut-loaded') !== 'true') {
            var sourcePanel = document.getElementById(sourceId);
            var sourceStyleCut = sourcePanel && sourcePanel.querySelector('.gta-style-cut');
            if (sourceStyleCut) body.appendChild(sourceStyleCut.cloneNode(true));
            body.setAttribute('data-gta-style-cut-loaded', 'true');
          }
          button.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    function setToggleState(isOpen) {
      document.querySelectorAll('.js-mobile-nav-toggle').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggle.setAttribute('aria-controls', 'gta-drawer');
        toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      });
    }

    function openDrawer(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (window.innerWidth >= BP) return;
      if (scrimTimer) window.clearTimeout(scrimTimer);
      scrim.hidden = false;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gta-drawer-open');
      window.requestAnimationFrame(function () {
        scrim.classList.add('is-active');
      });
      setToggleState(true);
      closeBtn.focus();
    }

    function closeDrawer(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gta-drawer-open');
      scrim.classList.remove('is-active');
      scrimTimer = window.setTimeout(function () {
        scrim.hidden = true;
      }, 250);
      setToggleState(false);
    }

    /* Delegate the toggle so sticky or rebuilt mobile headers keep working. */
    document.addEventListener('click', function (event) {
      var target = event.target;
      var toggle = target && target.closest ? target.closest('.js-mobile-nav-toggle') : null;
      if (toggle) openDrawer(event);
    }, true);
    closeBtn.addEventListener('click', closeDrawer);
    scrim.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        /* Close the drawer without cancelling the link's navigation. */
        closeDrawer();
      }
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.gta-nav')) closeAllPanels();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllPanels();
        closeDrawer();
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= BP) closeDrawer();
    });

    setToggleState(false);
    document.body.classList.add('gta-menu-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
}());
